import { TFunction } from "react-i18next";
import { mapToSignRequest } from "../helper/signGeneratorHelper";
import { IOrderStatus } from "../interfaces/IOrderStatus";
import { ISignForm } from "../interfaces/ISignForm";
import axios from "axios";

export const postOrder = async (
  form: ISignForm,
  setOrderStatus: React.Dispatch<React.SetStateAction<IOrderStatus>>,
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
  t: TFunction<"translation", undefined>
) => {
  setIsLoading(true);
  try {
    const request = mapToSignRequest(form);
    const formData = new FormData();
    formData.append("order", JSON.stringify(request));
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/create`,
      formData
    );

    if (response.status === 200) {
      setOrderStatus({
        orderSent: true,
        error: false,
        message: t("order.downloadConfirmation"),
      });
    }
  } catch (error) {
    setOrderStatus({
      orderSent: false,
      error: true,
      message: t("order.orderError"),
    });
  } finally {
    setIsLoading(false);
  }
};

export const dbWakeUp = async () => {
  try {
    await axios.get(`${process.env.REACT_APP_API_URL}/wake-up`);
  } catch (error) {}
};
